function CaseTable() {}
CaseTable.prototype = {
  '\uAB8A': '\u13BA',
  '\uAB8B': '\u13BB',
  '\uAB8C': '\u13BC',
  Ꚁ: '\uA681',
  '\uAB8D': '\u13BD',
  Ꙁ: '\uA641',
  '\uAB8E': '\u13BE',
  Ꚃ: '\uA683',
  '\uAB8F': '\u13BF',
  Ꙃ: '\uA643',
  Ꚅ: '\uA685',
  Ꙅ: '\uA645',
  Ꚇ: '\uA687',
  Ꙇ: '\uA647',
  Ꚉ: '\uA689',
  Ꙉ: '\uA649',
  Ự: '\u1EF1',
  Ằ: '\u1EB1',
  Ỳ: '\u1EF3',
  Ẳ: '\u1EB3',
  Ỵ: '\u1EF5',
  Ṡ: '\u1E61',
  Ꚋ: '\uA68B',
  Ẵ: '\u1EB5',
  Ḡ: '\u1E21',
  Ꙋ: '\uA64B',
  Ỷ: '\u1EF7',
  Ṣ: '\u1E63',
  Ꚍ: '\uA68D',
  Ặ: '\u1EB7',
  Ḣ: '\u1E23',
  Ꙍ: '\uA64D',
  Ỹ: '\u1EF9',
  Ṥ: '\u1E65',
  Ꚏ: '\uA68F',
  Ẹ: '\u1EB9',
  Ḥ: '\u1E25',
  Ꙏ: '\uA64F',
  Ṧ: '\u1E67',
  Ḧ: '\u1E27',
  Ṩ: '\u1E69',
  Ḩ: '\u1E29',
  Ỻ: '\u1EFB',
  Ẻ: '\u1EBB',
  Ỽ: '\u1EFD',
  Ẽ: '\u1EBD',
  Ỿ: '\u1EFF',
  Ṫ: '\u1E6B',
  Ế: '\u1EBF',
  Ḫ: '\u1E2B',
  Ṭ: '\u1E6D',
  Ḭ: '\u1E2D',
  Ṯ: '\u1E6F',
  Ḯ: '\u1E2F',
  Ա: '\u0561',
  Բ: '\u0562',
  Գ: '\u0563',
  Դ: '\u0564',
  Ե: '\u0565',
  Ƞ: '\u019E',
  Զ: '\u0566',
  Է: '\u0567',
  Ȣ: '\u0223',
  Ը: '\u0568',
  Թ: '\u0569',
  Ȥ: '\u0225',
  Ȧ: '\u0227',
  Ȩ: '\u0229',
  Ժ: '\u056A',
  Ի: '\u056B',
  Լ: '\u056C',
  Խ: '\u056D',
  Ծ: '\u056E',
  Կ: '\u056F',
  Ȫ: '\u022B',
  Ȭ: '\u022D',
  Ȯ: '\u022F',
  Ʞ: '\u029E',
  Ʇ: '\u0287',
  '\uA7B2': '\u029D',
  '\uA7B3': '\uAB53',
  Ꝡ: '\uA761',
  '\uA7B4': '\uA7B5',
  Ꝣ: '\uA763',
  '\uA7B6': '\uA7B7',
  Ꜣ: '\uA723',
  Ｐ: '\uFF50',
  Ꝥ: '\uA765',
  Ｑ: '\uFF51',
  '\uA7B8': '\uA7B9',
  Ꜥ: '\uA725',
  Ｒ: '\uFF52',
  Ꝧ: '\uA767',
  Ｓ: '\uFF53',
  Ꜧ: '\uA727',
  Ｔ: '\uFF54',
  Ꝩ: '\uA769',
  Ｕ: '\uFF55',
  Ꜩ: '\uA729',
  Ｖ: '\uFF56',
  Ｗ: '\uFF57',
  Ｘ: '\uFF58',
  Ｙ: '\uFF59',
  '\uA7BA': '\uA7BB',
  '\uA7BC': '\uA7BD',
  Ꝫ: '\uA76B',
  '\uA7BE': '\uA7BF',
  Ꜫ: '\uA72B',
  Ꝭ: '\uA76D',
  Ꜭ: '\uA72D',
  Ῐ: '\u1FD0',
  Ｚ: '\uFF5A',
  Ꝯ: '\uA76F',
  Ῑ: '\u1FD1',
  Ꜯ: '\uA72F',
  Ὀ: '\u1F40',
  Ὁ: '\u1F41',
  Ἀ: '\u1F00',
  Ἁ: '\u1F01',
  Ὶ: '\u1F76',
  Ί: '\u1F77',
  Ὂ: '\u1F42',
  Ὃ: '\u1F43',
  Ἂ: '\u1F02',
  Ὄ: '\u1F44',
  Ἃ: '\u1F03',
  Ὅ: '\u1F45',
  Ἄ: '\u1F04',
  Ἅ: '\u1F05',
  Ἆ: '\u1F06',
  ϐ: '\u03B2',
  Ἇ: '\u1F07',
  ϑ: '\u03B8',
  ϕ: '\u03C6',
  À: '\u00E0',
  Ⳁ: '\u2CC1',
  ϖ: '\u03C0',
  Á: '\u00E1',
  Â: '\u00E2',
  Ⳃ: '\u2CC3',
  Ϙ: '\u03D9',
  Ã: '\u00E3',
  Ɒ: '\u0252',
  Ä: '\u00E4',
  Ά: '\u03AC',
  '\u0345': '\u03B9',
  Ⳅ: '\u2CC5',
  Å: '\u00E5',
  Ⱳ: '\u2C73',
  Æ: '\u00E6',
  Έ: '\u03AD',
  Ⳇ: '\u2CC7',
  Ç: '\u00E7',
  Ή: '\u03AE',
  È: '\u00E8',
  Ⳉ: '\u2CC9',
  Ⱶ: '\u2C76',
  É: '\u00E9',
  Ϛ: '\u03DB',
  Ϝ: '\u03DD',
  Ί: '\u03AF',
  '\u{16E40}': '\u{16E60}',
  Ϟ: '\u03DF',
  '\u{16E41}': '\u{16E61}',
  Ê: '\u00EA',
  Ό: '\u03CC',
  '\u{16E42}': '\u{16E62}',
  Ⳋ: '\u2CCB',
  Ë: '\u00EB',
  '\u{16E43}': '\u{16E63}',
  Ì: '\u00EC',
  Ύ: '\u03CD',
  '\u{16E44}': '\u{16E64}',
  Ⳍ: '\u2CCD',
  Í: '\u00ED',
  Ώ: '\u03CE',
  '\u{16E45}': '\u{16E65}',
  Î: '\u00EE',
  '\u{16E46}': '\u{16E66}',
  Ⳏ: '\u2CCF',
  Ï: '\u00EF',
  '\u{16E47}': '\u{16E67}',
  '\u{16E48}': '\u{16E68}',
  '\u{16E49}': '\u{16E69}',
  Ȿ: '\u023F',
  Ɀ: '\u0240',
  Ⴠ: '\u2D20',
  Ⴡ: '\u2D21',
  Ⴢ: '\u2D22',
  Ⴣ: '\u2D23',
  '\u24B6': '\u24D0',
  Ⴤ: '\u2D24',
  '\u24B7': '\u24D1',
  Ⴥ: '\u2D25',
  '\u{16E4A}': '\u{16E6A}',
  '\u24B8': '\u24D2',
  '\u{16E4B}': '\u{16E6B}',
  '\u24B9': '\u24D3',
  Ⴧ: '\u2D27',
  '\u{16E4C}': '\u{16E6C}',
  '\u{16E4D}': '\u{16E6D}',
  '\u{16E4E}': '\u{16E6E}',
  '\u{16E4F}': '\u{16E6F}',
  '\u24BA': '\u24D4',
  '\u24BB': '\u24D5',
  '\u24BC': '\u24D6',
  '\u24BD': '\u24D7',
  '\u24BE': '\u24D8',
  '\u{10CA0}': '\u{10CE0}',
  '\u24BF': '\u24D9',
  Ⴭ: '\u2D2D',
  '\u{10CA1}': '\u{10CE1}',
  '\u{10CA2}': '\u{10CE2}',
  '\u{10C90}': '\u{10CD0}',
  '\u{10CA3}': '\u{10CE3}',
  '\u{10C91}': '\u{10CD1}',
  '\u{10CA4}': '\u{10CE4}',
  '\u{10C92}': '\u{10CD2}',
  '\u{10CA5}': '\u{10CE5}',
  '\u{10C93}': '\u{10CD3}',
  '\u{10CA6}': '\u{10CE6}',
  '\u{10C94}': '\u{10CD4}',
  '\u{10CA7}': '\u{10CE7}',
  '\u{10C95}': '\u{10CD5}',
  '\u{10CA8}': '\u{10CE8}',
  '\u{10C96}': '\u{10CD6}',
  '\u{10CA9}': '\u{10CE9}',
  '\u{10C97}': '\u{10CD7}',
  '\u{10C98}': '\u{10CD8}',
  '\u{10C99}': '\u{10CD9}',
  '\u{10CAA}': '\u{10CEA}',
  '\u{10CAB}': '\u{10CEB}',
  '\u{10CAC}': '\u{10CEC}',
  '\u{10C9A}': '\u{10CDA}',
  '\u{10CAD}': '\u{10CED}',
  '\u{10C9B}': '\u{10CDB}',
  '\u{10CAE}': '\u{10CEE}',
  '\u{10C9C}': '\u{10CDC}',
  '\u{10CAF}': '\u{10CEF}',
  '\u{10C9D}': '\u{10CDD}',
  '\u{10C9E}': '\u{10CDE}',
  '\u{104D0}': '\u{104F8}',
  '\u{10C9F}': '\u{10CDF}',
  '\u{104D1}': '\u{104F9}',
  '\u{104D2}': '\u{104FA}',
  '\u{104D3}': '\u{104FB}',
  '\u{10400}': '\u{10428}',
  '\u{10401}': '\u{10429}',
  '\u{10402}': '\u{1042A}',
  '\u{10403}': '\u{1042B}',
  Ӱ: '\u04F1',
  '\u{10404}': '\u{1042C}',
  Ұ: '\u04B1',
  '\u{10405}': '\u{1042D}',
  Ӳ: '\u04F3',
  '\u{10406}': '\u{1042E}',
  Ҳ: '\u04B3',
  '\u{10407}': '\u{1042F}',
  Ӵ: '\u04F5',
  Ѡ: '\u0461',
  '\u{10408}': '\u{10430}',
  Ҵ: '\u04B5',
  Ǡ: '\u01E1',
  Р: '\u0440',
  '\u{10409}': '\u{10431}',
  Ӷ: '\u04F7',
  Ơ: '\u01A1',
  Ѣ: '\u0463',
  С: '\u0441',
  Ҷ: '\u04B7',
  Ǣ: '\u01E3',
  Т: '\u0442',
  Ӹ: '\u04F9',
  Ƣ: '\u01A3',
  Ѥ: '\u0465',
  Ɛ: '\u025B',
  У: '\u0443',
  Ҹ: '\u04B9',
  Ǥ: '\u01E5',
  Ƒ: '\u0192',
  Ф: '\u0444',
  Ő: '\u0151',
  Ƥ: '\u01A5',
  Ѧ: '\u0467',
  Х: '\u0445',
  Đ: '\u0111',
  Ǧ: '\u01E7',
  Ɠ: '\u0260',
  Ц: '\u0446',
  Œ: '\u0153',
  Ʀ: '\u0280',
  Ѩ: '\u0469',
  Ɣ: '\u0263',
  Ч: '\u0447',
  Ē: '\u0113',
  Ǩ: '\u01E9',
  Ƨ: '\u01A8',
  Ш: '\u0448',
  Ŕ: '\u0155',
  '\u{1040A}': '\u{10432}',
  Ɩ: '\u0269',
  Щ: '\u0449',
  Ĕ: '\u0115',
  '\u{1040B}': '\u{10433}',
  Ʃ: '\u0283',
  Ɨ: '\u0268',
  Ŗ: '\u0157',
  '\u{1040C}': '\u{10434}',
  Ƙ: '\u0199',
  Ė: '\u0117',
  '\u{1040D}': '\u{10435}',
  Ӻ: '\u04FB',
  Ř: '\u0159',
  '\u{1040E}': '\u{10436}',
  Һ: '\u04BB',
  Ę: '\u0119',
  '\u{1040F}': '\u{10437}',
  Ӽ: '\u04FD',
  Ҽ: '\u04BD',
  Ӿ: '\u04FF',
  Ѫ: '\u046B',
  Ҿ: '\u04BF',
  Ǫ: '\u01EB',
  Ъ: '\u044A',
  Ѭ: '\u046D',
  Ы: '\u044B',
  Ǭ: '\u01ED',
  Ь: '\u044C',
  Ƭ: '\u01AD',
  Ѯ: '\u046F',
  Э: '\u044D',
  Ǯ: '\u01EF',
  Ю: '\u044E',
  Ś: '\u015B',
  Ʈ: '\u0288',
  Ɯ: '\u026F',
  Я: '\u044F',
  Ě: '\u011B',
  Ư: '\u01B0',
  Ɲ: '\u0272',
  Ŝ: '\u015D',
  '\uABA0': '\u13D0',
  Ĝ: '\u011D',
  '\uABA1': '\u13D1',
  Ɵ: '\u0275',
  Ş: '\u015F',
  '\uABA2': '\u13D2',
  '\uAB90': '\u13C0',
  Ğ: '\u011F',
  '\uABA3': '\u13D3',
  '\uAB91': '\u13C1',
  '\uABA4': '\u13D4',
  '\uAB92': '\u13C2',
  '\uABA5': '\u13D5',
  '\uAB93': '\u13C3',
  '\uABA6': '\u13D6',
  '\uAB94': '\u13C4',
  '\uABA7': '\u13D7',
  '\uAB95': '\u13C5',
  '\uABA8': '\u13D8',
  '\uAB96': '\u13C6',
  '\uABA9': '\u13D9',
  '\uAB97': '\u13C7',
  '\u{1E900}': '\u{1E922}',
  '\uAB98': '\u13C8',
  '\u{1E901}': '\u{1E923}',
  '\uAB99': '\u13C9',
  '\u{1E902}': '\u{1E924}',
  '\u{1E903}': '\u{1E925}',
  '\u{1E904}': '\u{1E926}',
  '\u{1E905}': '\u{1E927}',
  '\u{1E906}': '\u{1E928}',
  '\u{1E907}': '\u{1E929}',
  '\uABAA': '\u13DA',
  '\u{1E908}': '\u{1E92A}',
  '\uABAB': '\u13DB',
  '\u{1E909}': '\u{1E92B}',
  '\uABAC': '\u13DC',
  '\uAB9A': '\u13CA',
  '\uABAD': '\u13DD',
  '\uAB9B': '\u13CB',
  '\uABAE': '\u13DE',
  '\uAB9C': '\u13CC',
  Ꚑ: '\uA691',
  '\uABAF': '\u13DF',
  '\uAB9D': '\u13CD',
  Ꙑ: '\uA651',
  '\uAB9E': '\u13CE',
  Ꚓ: '\uA693',
  '\uAB9F': '\u13CF',
  Ꙓ: '\uA653',
  Ꚕ: '\uA695',
  Ꙕ: '\uA655',
  '\u{1E90A}': '\u{1E92C}',
  Ꚗ: '\uA697',
  '\u{1E90B}': '\u{1E92D}',
  Ꙗ: '\uA657',
  '\u{1E90C}': '\u{1E92E}',
  Ꚙ: '\uA699',
  '\u{1E90D}': '\u{1E92F}',
  Ꙙ: '\uA659',
  '\u{1E90E}': '\u{1E930}',
  '\u{1E90F}': '\u{1E931}',
  Ề: '\u1EC1',
  Ể: '\u1EC3',
  Ṱ: '\u1E71',
  Ꚛ: '\uA69B',
  Ễ: '\u1EC5',
  Ḱ: '\u1E31',
  Ꙛ: '\uA65B',
  Ṳ: '\u1E73',
  Ệ: '\u1EC7',
  Ḳ: '\u1E33',
  Ꙝ: '\uA65D',
  Ṵ: '\u1E75',
  Ỉ: '\u1EC9',
  Ḵ: '\u1E35',
  Ꙟ: '\uA65F',
  Ṷ: '\u1E77',
  Ḷ: '\u1E37',
  Ṹ: '\u1E79',
  Ḹ: '\u1E39',
  Ị: '\u1ECB',
  Ọ: '\u1ECD',
  Ṻ: '\u1E7B',
  Ỏ: '\u1ECF',
  Ḻ: '\u1E3B',
  Ṽ: '\u1E7D',
  Ḽ: '\u1E3D',
  Ṿ: '\u1E7F',
  Ḿ: '\u1E3F',
  Հ: '\u0570',
  Ձ: '\u0571',
  Ԁ: '\u0501',
  Ղ: '\u0572',
  Ճ: '\u0573',
  Ԃ: '\u0503',
  Մ: '\u0574',
  Յ: '\u0575',
  Ԅ: '\u0505',
  Ȱ: '\u0231',
  Ն: '\u0576',
  Շ: '\u0577',
  Ԇ: '\u0507',
  Ȳ: '\u0233',
  Ո: '\u0578',
  Չ: '\u0579',
  Ԉ: '\u0509',
  Պ: '\u057A',
  Ջ: '\u057B',
  Ԋ: '\u050B',
  Ռ: '\u057C',
  Ս: '\u057D',
  Ԍ: '\u050D',
  Վ: '\u057E',
  Տ: '\u057F',
  Ԏ: '\u050F',
  Ⱥ: '\u2C65',
  Ȼ: '\u023C',
  Ƚ: '\u019A',
  Ⱦ: '\u2C66',
  '\uA7C2': '\uA7C3',
  '\uA7C4': '\uA794',
  '\uA7C5': '\u0282',
  '\uA7C6': '\u1D8E',
  Ꜳ: '\uA733',
  Ꜵ: '\uA735',
  Ꜷ: '\uA737',
  Ꝺ: '\uA77A',
  Ꜹ: '\uA739',
  Ꝼ: '\uA77C',
  Ꜻ: '\uA73B',
  Ᵹ: '\u1D79',
  Ꜽ: '\uA73D',
  Ῠ: '\u1FE0',
  '\u1C80': '\u0432',
  Ꝿ: '\uA77F',
  Ῡ: '\u1FE1',
  '\u1C81': '\u0434',
  Ꜿ: '\uA73F',
  '\u1C82': '\u043E',
  '\u1C83': '\u0441',
  '\u1C84': '\u0442',
  Ὑ: '\u1F51',
  Ἐ: '\u1F10',
  '\u1C85': '\u0442',
  Ἑ: '\u1F11',
  '\u1C86': '\u044A',
  '\u1C87': '\u0463',
  '\u1C88': '\uA64B',
  Ὺ: '\u1F7A',
  Ύ: '\u1F7B',
  Ῥ: '\u1FE5',
  Ὓ: '\u1F53',
  Ἒ: '\u1F12',
  Ἓ: '\u1F13',
  Ὕ: '\u1F55',
  Ἔ: '\u1F14',
  Ἕ: '\u1F15',
  Ὗ: '\u1F57',
  Ϡ: '\u03E1',
  Π: '\u03C0',
  Ϣ: '\u03E3',
  Ρ: '\u03C1',
  Α: '\u03B1',
  Ϥ: '\u03E5',
  Σ: '\u03C3',
  Ð: '\u00F0',
  Β: '\u03B2',
  Τ: '\u03C4',
  Ⳑ: '\u2CD1',
  Ñ: '\u00F1',
  Γ: '\u03B3',
  Ϧ: '\u03E7',
  Υ: '\u03C5',
  Ò: '\u00F2',
  Δ: '\u03B4',
  Φ: '\u03C6',
  Ⳓ: '\u2CD3',
  Ó: '\u00F3',
  Ε: '\u03B5',
  Ϩ: '\u03E9',
  Χ: '\u03C7',
  Ⲁ: '\u2C81',
  Ô: '\u00F4',
  Ζ: '\u03B6',
  Ψ: '\u03C8',
  Ⳕ: '\u2CD5',
  Õ: '\u00F5',
  Η: '\u03B7',
  A: '\u0061',
  Ω: '\u03C9',
  Ⲃ: '\u2C83',
  Ⰰ: '\u2C30',
  Ö: '\u00F6',
  Θ: '\u03B8',
  B: '\u0062',
  Ⳗ: '\u2CD7',
  Ⰱ: '\u2C31',
  Ι: '\u03B9',
  C: '\u0063',
  Ⲅ: '\u2C85',
  Ⰲ: '\u2C32',
  Ø: '\u00F8',
  D: '\u0064',
  Ⳙ: '\u2CD9',
  Ⰳ: '\u2C33',
  Ù: '\u00F9',
  E: '\u0065',
  Ⲇ: '\u2C87',
  Ⰴ: '\u2C34',
  F: '\u0066',
  Ⰵ: '\u2C35',
  G: '\u0067',
  Ⲉ: '\u2C89',
  Ⰶ: '\u2C36',
  H: '\u0068',
  Ϫ: '\u03EB',
  Ⰷ: '\u2C37',
  I: '\u0069',
  Ϊ: '\u03CA',
  Ⰸ: '\u2C38',
  Ϭ: '\u03ED',
  Ϋ: '\u03CB',
  Ⰹ: '\u2C39',
  Κ: '\u03BA',
  '\u{16E50}': '\u{16E70}',
  Λ: '\u03BB',
  Ϯ: '\u03EF',
  '\u{16E51}': '\u{16E71}',
  Μ: '\u03BC',
  Ú: '\u00FA',
  '\u{16E52}': '\u{16E72}',
  Ⳛ: '\u2CDB',
  Ν: '\u03BD',
  Û: '\u00FB',
  '\u{16E53}': '\u{16E73}',
  Ξ: '\u03BE',
  Ü: '\u00FC',
  '\u{16E54}': '\u{16E74}',
  Ⳝ: '\u2CDD',
  Ο: '\u03BF',
  Ý: '\u00FD',
  '\u{16E55}': '\u{16E75}',
  Ⲋ: '\u2C8B',
  J: '\u006A',
  Þ: '\u00FE',
  '\u{16E56}': '\u{16E76}',
  Ⳟ: '\u2CDF',
  K: '\u006B',
  '\u{16E57}': '\u{16E77}',
  Ⲍ: '\u2C8D',
  Ⰺ: '\u2C3A',
  L: '\u006C',
  '\u{16E58}': '\u{16E78}',
  Ⰻ: '\u2C3B',
  M: '\u006D',
  '\u{16E59}': '\u{16E79}',
  Ⲏ: '\u2C8F',
  Ⰼ: '\u2C3C',
  '\u24C0': '\u24DA',
  N: '\u006E',
  Ⰽ: '\u2C3D',
  '\u24C1': '\u24DB',
  O: '\u006F',
  Ⰾ: '\u2C3E',
  '\u24C2': '\u24DC',
  Ⰿ: '\u2C3F',
  '\u24C3': '\u24DD',
  '\u24C4': '\u24DE',
  '\u24C5': '\u24DF',
  '\u24C6': '\u24E0',
  '\u24C7': '\u24E1',
  '\u{16E5A}': '\u{16E7A}',
  '\u24C8': '\u24E2',
  Ⅰ: '\u2170',
  '\u{16E5B}': '\u{16E7B}',
  '\u24C9': '\u24E3',
  Ⅱ: '\u2171',
  '\u{16E5C}': '\u{16E7C}',
  Ⅲ: '\u2172',
  '\u{16E5D}': '\u{16E7D}',
  Ⅳ: '\u2173',
  '\u{16E5E}': '\u{16E7E}',
  Ⅴ: '\u2174',
  '\u{16E5F}': '\u{16E7F}',
  Ⅵ: '\u2175',
  Ⅶ: '\u2176',
  Ⅷ: '\u2177',
  Ω: '\u03C9',
  Ⅸ: '\u2178',
  '\u24CA': '\u24E4',
  Ⅹ: '\u2179',
  '\u24CB': '\u24E5',
  '\u24CC': '\u24E6',
  '\u24CD': '\u24E7',
  '\u24CE': '\u24E8',
  '\u{10CB0}': '\u{10CF0}',
  '\u24CF': '\u24E9',
  '\u{10CB1}': '\u{10CF1}',
  '\u{10CB2}': '\u{10CF2}',
  Ⅺ: '\u217A',
  Ⅻ: '\u217B',
  K: '\u006B',
  Ⅼ: '\u217C',
  Å: '\u00E5',
  Ⅽ: '\u217D',
  Ⅾ: '\u217E',
  Ⅿ: '\u217F',
  '\u{10410}': '\u{10438}',
  '\u{10411}': '\u{10439}',
  '\u{10412}': '\u{1043A}',
  '\u{10413}': '\u{1043B}',
  '\u{10414}': '\u{1043C}',
  Ӏ: '\u04CF',
  '\u{10415}': '\u{1043D}',
  Ӂ: '\u04C2',
  '\u{10416}': '\u{1043E}',
  '\u{10417}': '\u{1043F}',
  Ӄ: '\u04C4',
  Ѱ: '\u0471',
  '\u{10418}': '\u{10440}',
  '\u{10419}': '\u{10441}',
  Ӆ: '\u04C6',
  Ѳ: '\u0473',
  Ǳ: '\u01F3',
  ǲ: '\u01F3',
  Ʊ: '\u028A',
  Ӈ: '\u04C8',
  Ѵ: '\u0475',
  Ʋ: '\u028B',
  Š: '\u0161',
  Ǵ: '\u01F5',
  Ƴ: '\u01B4',
  Ӊ: '\u04CA',
  Ѷ: '\u0477',
  Ġ: '\u0121',
  Ţ: '\u0163',
  Ƕ: '\u0195',
  Ƶ: '\u01B6',
  Ģ: '\u0123',
  Ƿ: '\u01BF',
  Ѹ: '\u0479',
  Ť: '\u0165',
  Ǹ: '\u01F9',
  Ʒ: '\u0292',
  '\u{1041A}': '\u{10442}',
  Ĥ: '\u0125',
  Ƹ: '\u01B9',
  '\u{1041B}': '\u{10443}',
  Ŧ: '\u0167',
  '\u{1041C}': '\u{10444}',
  Ħ: '\u0127',
  '\u{1041D}': '\u{10445}',
  Ũ: '\u0169',
  '\u{1041E}': '\u{10446}',
  Ĩ: '\u0129',
  '\u{1041F}': '\u{10447}',
  Ӌ: '\u04CC',
  Ӎ: '\u04CE',
  Ѻ: '\u047B',
  Ǻ: '\u01FB',
  Ѽ: '\u047D',
  Ǽ: '\u01FD',
  Ƽ: '\u01BD',
  Ѿ: '\u047F',
  Ū: '\u016B',
  Ǿ: '\u01FF',
  Ī: '\u012B',
  Ŭ: '\u016D',
  '\uABB0': '\u13E0',
  Ĭ: '\u012D',
  '\uABB1': '\u13E1',
  Ů: '\u016F',
  '\uABB2': '\u13E2',
  Į: '\u012F',
  '\uABB3': '\u13E3',
  '\uABB4': '\u13E4',
  '\uABB5': '\u13E5',
  '\uABB6': '\u13E6',
  '\uABB7': '\u13E7',
  '\uABB8': '\u13E8',
  '\uABB9': '\u13E9',
  '\u{1E910}': '\u{1E932}',
  '\u{1E911}': '\u{1E933}',
  '\u{1E912}': '\u{1E934}',
  '\u{1E913}': '\u{1E935}',
  '\u{1E914}': '\u{1E936}',
  '\u{1E915}': '\u{1E937}',
  '\u{1E916}': '\u{1E938}',
  '\u{1E917}': '\u{1E939}',
  '\uABBA': '\u13EA',
  '\u{1E918}': '\u{1E93A}',
  '\uABBB': '\u13EB',
  '\u{1E919}': '\u{1E93B}',
  '\uABBC': '\u13EC',
  '\uABBD': '\u13ED',
  '\uABBE': '\u13EE',
  '\uABBF': '\u13EF',
  Ꙡ: '\uA661',
  Ꙣ: '\uA663',
  Ꙥ: '\uA665',
  '\u{1E91A}': '\u{1E93C}',
  '\u{1E91B}': '\u{1E93D}',
  Ꙧ: '\uA667',
  '\u{1E91C}': '\u{1E93E}',
  '\u{1E91D}': '\u{1E93F}',
  Ꙩ: '\uA669',
  '\u{1E91E}': '\u{1E940}',
  '\u{1E91F}': '\u{1E941}',
  Ố: '\u1ED1',
  Ồ: '\u1ED3',
  Ẁ: '\u1E81',
  Ổ: '\u1ED5',
  Ṁ: '\u1E41',
  Ꙫ: '\uA66B',
  Ẃ: '\u1E83',
  Ḁ: '\u1E01',
  Ỗ: '\u1ED7',
  Ṃ: '\u1E43',
  Ꙭ: '\uA66D',
  Ẅ: '\u1E85',
  Ḃ: '\u1E03',
  Ộ: '\u1ED9',
  Ṅ: '\u1E45',
  Ẇ: '\u1E87',
  Ḅ: '\u1E05',
  Ṇ: '\u1E47',
  Ẉ: '\u1E89',
  Ḇ: '\u1E07',
  Ṉ: '\u1E49',
  Ḉ: '\u1E09',
  Ớ: '\u1EDB',
  Ờ: '\u1EDD',
  Ẋ: '\u1E8B',
  Ở: '\u1EDF',
  Ṋ: '\u1E4B',
  Ẍ: '\u1E8D',
  Ḋ: '\u1E0B',
  Ṍ: '\u1E4D',
  Ẏ: '\u1E8F',
  Ḍ: '\u1E0D',
  Ṏ: '\u1E4F',
  Ր: '\u0580',
  Ḏ: '\u1E0F',
  Ց: '\u0581',
  Ԑ: '\u0511',
  Ւ: '\u0582',
  Փ: '\u0583',
  Ԓ: '\u0513',
  Ք: '\u0584',
  Օ: '\u0585',
  Ԕ: '\u0515',
  Ֆ: '\u0586',
  Ɂ: '\u0242',
  Ȁ: '\u0201',
  Ԗ: '\u0517',
  Ƀ: '\u0180',
  Ȃ: '\u0203',
  Ԙ: '\u0519',
  Ʉ: '\u0289',
  Ʌ: '\u028C',
  Ȅ: '\u0205',
  '\u13F8': '\u13F0',
  Ɇ: '\u0247',
  '\u13F9': '\u13F1',
  Ȇ: '\u0207',
  Ɉ: '\u0249',
  Ȉ: '\u0209',
  Ԛ: '\u051B',
  '\u13FA': '\u13F2',
  Ԝ: '\u051D',
  '\u13FB': '\u13F3',
  '\u13FC': '\u13F4',
  Ԟ: '\u051F',
  Ɋ: '\u024B',
  '\u13FD': '\u13F5',
  Ȋ: '\u020B',
  Ɍ: '\u024D',
  Ȍ: '\u020D',
  Ɏ: '\u024F',
  Ȏ: '\u020F',
  Ꞁ: '\uA781',
  Ꝁ: '\uA741',
  Ꞃ: '\uA783',
  Ꝃ: '\uA743',
  Ꞅ: '\uA785',
  Ꝅ: '\uA745',
  Ꞇ: '\uA787',
  Ꝇ: '\uA747',
  Ꝉ: '\uA749',
  Ꞌ: '\uA78C',
  Ꝋ: '\uA74B',
  '\u1CA0': '\u10E0',
  '\u1CA1': '\u10E1',
  Ɥ: '\u0265',
  Ꝍ: '\uA74D',
  Ὸ: '\u1F78',
  '\u1CA2': '\u10E2',
  '\u1C90': '\u10D0',
  Ό: '\u1F79',
  Ᾰ: '\u1FB0',
  '\u1CA3': '\u10E3',
  '\u1C91': '\u10D1',
  Ꝏ: '\uA74F',
  Ᾱ: '\u1FB1',
  '\u1CA4': '\u10E4',
  '\u1C92': '\u10D2',
  '\u1CA5': '\u10E5',
  '\u1C93': '\u10D3',
  Ὠ: '\u1F60',
  '\u1CA6': '\u10E6',
  '\u1C94': '\u10D4',
  Ὡ: '\u1F61',
  Ἠ: '\u1F20',
  '\u1CA7': '\u10E7',
  '\u1C95': '\u10D5',
  Ἡ: '\u1F21',
  '\u1CA8': '\u10E8',
  '\u1C96': '\u10D6',
  '\u1CA9': '\u10E9',
  '\u1C97': '\u10D7',
  '\u1C98': '\u10D8',
  Ὼ: '\u1F7C',
  '\u1C99': '\u10D9',
  Ώ: '\u1F7D',
  Ὰ: '\u1F70',
  Ά: '\u1F71',
  Ὢ: '\u1F62',
  ι: '\u03B9',
  Ὣ: '\u1F63',
  Ἢ: '\u1F22',
  Ὤ: '\u1F64',
  Ἣ: '\u1F23',
  '\u1CAA': '\u10EA',
  Ὥ: '\u1F65',
  Ἤ: '\u1F24',
  '\u1CAB': '\u10EB',
  Ὦ: '\u1F66',
  Ἥ: '\u1F25',
  '\u1CAC': '\u10EC',
  '\u1C9A': '\u10DA',
  Ὧ: '\u1F67',
  Ἦ: '\u1F26',
  '\u1CAD': '\u10ED',
  '\u1C9B': '\u10DB',
  ϰ: '\u03BA',
  Ἧ: '\u1F27',
  '\u1CAE': '\u10EE',
  '\u1C9C': '\u10DC',
  ϱ: '\u03C1',
  '\u1CAF': '\u10EF',
  '\u1C9D': '\u10DD',
  '\u1C9E': '\u10DE',
  '\u1C9F': '\u10DF',
  ϴ: '\u03B8',
  ϵ: '\u03B5',
  Ⳡ: '\u2CE1',
  Ⲡ: '\u2CA1',
  Ϸ: '\u03F8',
  Ⳣ: '\u2CE3',
  Ⲣ: '\u2CA3',
  Ⲑ: '\u2C91',
  Ϲ: '\u03F2',
  P: '\u0070',
  Q: '\u0071',
  Ⲥ: '\u2CA5',
  Ⲓ: '\u2C93',
  Ⱀ: '\u2C40',
  R: '\u0072',
  Ⱁ: '\u2C41',
  S: '\u0073',
  Ⲧ: '\u2CA7',
  Ⲕ: '\u2C95',
  Ⱂ: '\u2C42',
  T: '\u0074',
  Ⱃ: '\u2C43',
  U: '\u0075',
  Ⲩ: '\u2CA9',
  Ⲗ: '\u2C97',
  Ⱄ: '\u2C44',
  V: '\u0076',
  Ⱅ: '\u2C45',
  W: '\u0077',
  Ⲙ: '\u2C99',
  Ⱆ: '\u2C46',
  Ϻ: '\u03FB',
  X: '\u0078',
  Ⱇ: '\u2C47',
  Y: '\u0079',
  Ⱈ: '\u2C48',
  Ⱉ: '\u2C49',
  Ͻ: '\u037B',
  Ͼ: '\u037C',
  Ͽ: '\u037D',
  Ⳬ: '\u2CEC',
  Ⲫ: '\u2CAB',
  Ⳮ: '\u2CEE',
  Ⲭ: '\u2CAD',
  Ⲛ: '\u2C9B',
  Z: '\u007A',
  Ⲯ: '\u2CAF',
  Ⲝ: '\u2C9D',
  Ⱊ: '\u2C4A',
  Ⱋ: '\u2C4B',
  Ⲟ: '\u2C9F',
  Ⱌ: '\u2C4C',
  Ⱍ: '\u2C4D',
  Ⱎ: '\u2C4E',
  Ⱏ: '\u2C4F',
  Ⴀ: '\u2D00',
  Ⴁ: '\u2D01',
  Ⴂ: '\u2D02',
  Ⴃ: '\u2D03',
  Ⴄ: '\u2D04',
  Ⴅ: '\u2D05',
  Ⴆ: '\u2D06',
  Ⴇ: '\u2D07',
  Ⅎ: '\u214E',
  Ⴈ: '\u2D08',
  Ⴉ: '\u2D09',
  Ⴊ: '\u2D0A',
  Ⴋ: '\u2D0B',
  Ⴌ: '\u2D0C',
  Ⴍ: '\u2D0D',
  Ⴎ: '\u2D0E',
  Ⴏ: '\u2D0F',
  '\u{118A0}': '\u{118C0}',
  '\u{118A1}': '\u{118C1}',
  '\u{118A2}': '\u{118C2}',
  '\u{104B0}': '\u{104D8}',
  '\u{118A3}': '\u{118C3}',
  '\u{104B1}': '\u{104D9}',
  '\u{118A4}': '\u{118C4}',
  '\u{104B2}': '\u{104DA}',
  '\u{118A5}': '\u{118C5}',
  '\u{104B3}': '\u{104DB}',
  '\u{118A6}': '\u{118C6}',
  '\u{104B4}': '\u{104DC}',
  '\u{10420}': '\u{10448}',
  '\u{118A7}': '\u{118C7}',
  '\u{104B5}': '\u{104DD}',
  '\u{10421}': '\u{10449}',
  '\u{118A8}': '\u{118C8}',
  '\u{104B6}': '\u{104DE}',
  '\u{10422}': '\u{1044A}',
  '\u{118A9}': '\u{118C9}',
  '\u{104B7}': '\u{104DF}',
  '\u{10423}': '\u{1044B}',
  '\u{104B8}': '\u{104E0}',
  '\u{10424}': '\u{1044C}',
  Ӑ: '\u04D1',
  '\u{104B9}': '\u{104E1}',
  '\u{10425}': '\u{1044D}',
  '\u{10426}': '\u{1044E}',
  Ӓ: '\u04D3',
  '\u{10427}': '\u{1044F}',
  Ҁ: '\u0481',
  Ӕ: '\u04D5',
  Ѐ: '\u0450',
  Ӗ: '\u04D7',
  Ё: '\u0451',
  '\u{118AA}': '\u{118CA}',
  Ђ: '\u0452',
  '\u{118AB}': '\u{118CB}',
  Ә: '\u04D9',
  Ű: '\u0171',
  Ѓ: '\u0453',
  '\u{118AC}': '\u{118CC}',
  '\u{104BA}': '\u{104E2}',
  Ǆ: '\u01C6',
  Є: '\u0454',
  '\u{118AD}': '\u{118CD}',
  '\u{104BB}': '\u{104E3}',
  ǅ: '\u01C6',
  Ų: '\u0173',
  Ѕ: '\u0455',
  '\u{118AE}': '\u{118CE}',
  '\u{104BC}': '\u{104E4}',
  І: '\u0456',
  Ĳ: '\u0133',
  '\u{118AF}': '\u{118CF}',
  '\u{104BD}': '\u{104E5}',
  Ǉ: '\u01C9',
  Ŵ: '\u0175',
  Ї: '\u0457',
  '\u{104BE}': '\u{104E6}',
  ǈ: '\u01C9',
  Ј: '\u0458',
  Ĵ: '\u0135',
  '\u{104BF}': '\u{104E7}',
  Ŷ: '\u0177',
  Љ: '\u0459',
  Ķ: '\u0137',
  Ÿ: '\u00FF',
  Ӛ: '\u04DB',
  Ź: '\u017A',
  Ĺ: '\u013A',
  Ӝ: '\u04DD',
  Ҋ: '\u048B',
  Ӟ: '\u04DF',
  Ǌ: '\u01CC',
  Ҍ: '\u048D',
  Њ: '\u045A',
  ǋ: '\u01CC',
  Ћ: '\u045B',
  Ҏ: '\u048F',
  Ќ: '\u045C',
  Ǎ: '\u01CE',
  Ѝ: '\u045D',
  Ż: '\u017C',
  Ў: '\u045E',
  Ǐ: '\u01D0',
  Џ: '\u045F',
  Ļ: '\u013C',
  Ž: '\u017E',
  Ľ: '\u013E',
  ſ: '\u0073',
  '\uAB70': '\u13A0',
  Ŀ: '\u0140',
  '\uAB71': '\u13A1',
  '\uAB72': '\u13A2',
  '\uAB73': '\u13A3',
  '\uAB74': '\u13A4',
  '\uAB75': '\u13A5',
  '\uAB76': '\u13A6',
  '\u{1E920}': '\u{1E942}',
  '\uAB77': '\u13A7',
  '\u{1E921}': '\u{1E943}',
  '\uAB78': '\u13A8',
  '\uAB79': '\u13A9',
  '\uAB7A': '\u13AA',
  '\uAB7B': '\u13AB',
  '\uAB7C': '\u13AC',
  '\uAB7D': '\u13AD',
  '\uAB7E': '\u13AE',
  '\uAB7F': '\u13AF',
  Ỡ: '\u1EE1',
  Ạ: '\u1EA1',
  Ợ: '\u1EE3',
  Ả: '\u1EA3',
  Ẑ: '\u1E91',
  Ụ: '\u1EE5',
  Ṑ: '\u1E51',
  Ấ: '\u1EA5',
  Ẓ: '\u1E93',
  Ḑ: '\u1E11',
  Ủ: '\u1EE7',
  Ṓ: '\u1E53',
  Ầ: '\u1EA7',
  Ẕ: '\u1E95',
  Ḓ: '\u1E13',
  Ứ: '\u1EE9',
  Ṕ: '\u1E55',
  Ẩ: '\u1EA9',
  Ḕ: '\u1E15',
  Ṗ: '\u1E57',
  Ḗ: '\u1E17',
  Ṙ: '\u1E59',
  Ḙ: '\u1E19',
  Ừ: '\u1EEB',
  Ẫ: '\u1EAB',
  Ử: '\u1EED',
  Ậ: '\u1EAD',
  Ữ: '\u1EEF',
  ẛ: '\u1E61',
  Ṛ: '\u1E5B',
  Ắ: '\u1EAF',
  Ḛ: '\u1E1B',
  Ṝ: '\u1E5D',
  Ḝ: '\u1E1D',
  Ṟ: '\u1E5F',
  Ḟ: '\u1E1F',
  Ԡ: '\u0521',
  Ԣ: '\u0523',
  Ԥ: '\u0525',
  Ȑ: '\u0211',
  Ԧ: '\u0527',
  Ȓ: '\u0213',
  Ԩ: '\u0529',
  Ȕ: '\u0215',
  Ȗ: '\u0217',
  Ș: '\u0219',
  Ԫ: '\u052B',
  Ԭ: '\u052D',
  Ԯ: '\u052F',
  Ț: '\u021B',
  Ȝ: '\u021D',
  Ȟ: '\u021F',
  Ꞡ: '\uA7A1',
  Ꞣ: '\uA7A3',
  Ꞑ: '\uA791',
  Ꝑ: '\uA751',
  Ꞥ: '\uA7A5',
  Ꞓ: '\uA793',
  Ꝓ: '\uA753',
  Ꞧ: '\uA7A7',
  Ꝕ: '\uA755',
  Ａ: '\uFF41',
  Ꞩ: '\uA7A9',
  Ꞗ: '\uA797',
  Ｂ: '\uFF42',
  Ꝗ: '\uA757',
  Ｃ: '\uFF43',
  Ꞙ: '\uA799',
  Ｄ: '\uFF44',
  Ꝙ: '\uA759',
  Ｅ: '\uFF45',
  Ｆ: '\uFF46',
  Ｇ: '\uFF47',
  Ｈ: '\uFF48',
  Ｉ: '\uFF49',
  Ɦ: '\u0266',
  Ɜ: '\u025C',
  Ɡ: '\u0261',
  Ꞛ: '\uA79B',
  Ɬ: '\u026C',
  Ꝛ: '\uA75B',
  '\u1CB0': '\u10F0',
  '\uA7AE': '\u026A',
  Ꞝ: '\uA79D',
  '\u1CB1': '\u10F1',
  Ꝝ: '\uA75D',
  '\u1CB2': '\u10F2',
  Ꞟ: '\uA79F',
  Ὲ: '\u1F72',
  '\u1CB3': '\u10F3',
  Ｊ: '\uFF4A',
  Ꝟ: '\uA75F',
  Έ: '\u1F73',
  '\u1CB4': '\u10F4',
  Ｋ: '\uFF4B',
  '\u1CB5': '\u10F5',
  Ｌ: '\uFF4C',
  '\u1CB6': '\u10F6',
  Ｍ: '\uFF4D',
  Ἰ: '\u1F30',
  '\u1CB7': '\u10F7',
  Ｎ: '\uFF4E',
  Ἱ: '\u1F31',
  '\u1CB8': '\u10F8',
  Ｏ: '\uFF4F',
  '\u1CB9': '\u10F9',
  Ὴ: '\u1F74',
  Ή: '\u1F75',
  Ἲ: '\u1F32',
  Ἳ: '\u1F33',
  '\u1CBA': '\u10FA',
  Ἴ: '\u1F34',
  Ἵ: '\u1F35',
  Ἶ: '\u1F36',
  '\u1CBD': '\u10FD',
  Ἷ: '\u1F37',
  '\u1CBE': '\u10FE',
  '\u1CBF': '\u10FF',
  ς: '\u03C3',
  Ͱ: '\u0371',
  Ͳ: '\u0373',
  Ⲱ: '\u2CB1',
  Ⳳ: '\u2CF3',
  Ⲳ: '\u2CB3',
  Ⱡ: '\u2C61',
  Ͷ: '\u0377',
  Ⲵ: '\u2CB5',
  Ⱐ: '\u2C50',
  µ: '\u03BC',
  Ɫ: '\u026B',
  Ⱑ: '\u2C51',
  Ⲷ: '\u2CB7',
  Ᵽ: '\u1D7D',
  Ⱒ: '\u2C52',
  Ɽ: '\u027D',
  Ⱓ: '\u2C53',
  Ⲹ: '\u2CB9',
  Ⱔ: '\u2C54',
  Ⱕ: '\u2C55',
  Ⱨ: '\u2C68',
  Ⱖ: '\u2C56',
  Ⱗ: '\u2C57',
  Ⱪ: '\u2C6A',
  Ⱘ: '\u2C58',
  Ⱙ: '\u2C59',
  Ϗ: '\u03D7',
  Ⲻ: '\u2CBB',
  Ⲽ: '\u2CBD',
  Ϳ: '\u03F3',
  Ⲿ: '\u2CBF',
  Ⱬ: '\u2C6C',
  Ⱚ: '\u2C5A',
  Ⱛ: '\u2C5B',
  Ɑ: '\u0251',
  Ⱜ: '\u2C5C',
  Ɱ: '\u0271',
  Ⱝ: '\u2C5D',
  Ɐ: '\u0250',
  Ⱞ: '\u2C5E',
  Ⴐ: '\u2D10',
  Ⴑ: '\u2D11',
  Ⴒ: '\u2D12',
  Ⴓ: '\u2D13',
  Ⴔ: '\u2D14',
  Ⴕ: '\u2D15',
  Ⴖ: '\u2D16',
  Ⴗ: '\u2D17',
  Ↄ: '\u2184',
  Ⴘ: '\u2D18',
  Ⴙ: '\u2D19',
  Ⴚ: '\u2D1A',
  Ⴛ: '\u2D1B',
  Ⴜ: '\u2D1C',
  Ⴝ: '\u2D1D',
  Ⴞ: '\u2D1E',
  '\u{10C80}': '\u{10CC0}',
  Ⴟ: '\u2D1F',
  '\u{10C81}': '\u{10CC1}',
  '\u{10C82}': '\u{10CC2}',
  '\u{10C83}': '\u{10CC3}',
  '\u{10C84}': '\u{10CC4}',
  '\u{10C85}': '\u{10CC5}',
  '\u{10C86}': '\u{10CC6}',
  '\u{10C87}': '\u{10CC7}',
  '\u{10C88}': '\u{10CC8}',
  '\u{10C89}': '\u{10CC9}',
  '\u{10C8A}': '\u{10CCA}',
  '\u{10C8B}': '\u{10CCB}',
  '\u{118B0}': '\u{118D0}',
  '\u{10C8C}': '\u{10CCC}',
  '\u{118B1}': '\u{118D1}',
  '\u{10C8D}': '\u{10CCD}',
  '\u{118B2}': '\u{118D2}',
  '\u{10C8E}': '\u{10CCE}',
  '\u{104C0}': '\u{104E8}',
  '\u{118B3}': '\u{118D3}',
  '\u{10C8F}': '\u{10CCF}',
  '\u{104C1}': '\u{104E9}',
  '\u{118B4}': '\u{118D4}',
  '\u{104C2}': '\u{104EA}',
  '\u{118B5}': '\u{118D5}',
  '\u{104C3}': '\u{104EB}',
  '\u{118B6}': '\u{118D6}',
  '\u{104C4}': '\u{104EC}',
  '\u{118B7}': '\u{118D7}',
  '\u{104C5}': '\u{104ED}',
  '\u{118B8}': '\u{118D8}',
  '\u{104C6}': '\u{104EE}',
  '\u{118B9}': '\u{118D9}',
  '\u{104C7}': '\u{104EF}',
  '\u{104C8}': '\u{104F0}',
  Ӡ: '\u04E1',
  '\u{104C9}': '\u{104F1}',
  Ҡ: '\u04A1',
  Ӣ: '\u04E3',
  Ґ: '\u0491',
  Ң: '\u04A3',
  Ӥ: '\u04E5',
  А: '\u0430',
  Ҥ: '\u04A5',
  Ғ: '\u0493',
  Ӧ: '\u04E7',
  Б: '\u0431',
  Ǒ: '\u01D2',
  '\u{118BA}': '\u{118DA}',
  В: '\u0432',
  Ҧ: '\u04A7',
  Ҕ: '\u0495',
  '\u{118BB}': '\u{118DB}',
  Ө: '\u04E9',
  Г: '\u0433',
  Ǔ: '\u01D4',
  '\u{118BC}': '\u{118DC}',
  '\u{104CA}': '\u{104F2}',
  Ɓ: '\u0253',
  Д: '\u0434',
  Ҩ: '\u04A9',
  Җ: '\u0497',
  '\u{118BD}': '\u{118DD}',
  '\u{104CB}': '\u{104F3}',
  Ƃ: '\u0183',
  Е: '\u0435',
  Ł: '\u0142',
  Ā: '\u0101',
  Ǖ: '\u01D6',
  '\u{118BE}': '\u{118DE}',
  '\u{104CC}': '\u{104F4}',
  Ж: '\u0436',
  Ҙ: '\u0499',
  '\u{118BF}': '\u{118DF}',
  '\u{104CD}': '\u{104F5}',
  Ƅ: '\u0185',
  З: '\u0437',
  Ń: '\u0144',
  Ă: '\u0103',
  Ǘ: '\u01D8',
  '\u{104CE}': '\u{104F6}',
  И: '\u0438',
  '\u{104CF}': '\u{104F7}',
  Ɔ: '\u0254',
  Й: '\u0439',
  Ņ: '\u0146',
  Ą: '\u0105',
  Ǚ: '\u01DA',
  Ƈ: '\u0188',
  Ň: '\u0148',
  Ć: '\u0107',
  Ӫ: '\u04EB',
  Ɖ: '\u0256',
  Ĉ: '\u0109',
  Ҫ: '\u04AB',
  Ӭ: '\u04ED',
  Ҭ: '\u04AD',
  Қ: '\u049B',
  Ӯ: '\u04EF',
  К: '\u043A',
  Ү: '\u04AF',
  Ҝ: '\u049D',
  Л: '\u043B',
  Ǜ: '\u01DC',
  М: '\u043C',
  Ҟ: '\u049F',
  Ɗ: '\u0257',
  Н: '\u043D',
  Ƌ: '\u018C',
  О: '\u043E',
  Ŋ: '\u014B',
  Ǟ: '\u01DF',
  П: '\u043F',
  Ċ: '\u010B',
  Ō: '\u014D',
  Ǝ: '\u01DD',
  Č: '\u010D',
  Ə: '\u0259',
  Ŏ: '\u014F',
  '\uAB80': '\u13B0',
  Ď: '\u010F',
  '\uAB81': '\u13B1',
  '\uAB82': '\u13B2',
  '\uAB83': '\u13B3',
  '\uAB84': '\u13B4',
  '\uAB85': '\u13B5',
  '\uAB86': '\u13B6',
  '\uAB87': '\u13B7',
  '\uAB88': '\u13B8',
  '\uAB89': '\u13B9',
};
const full = Object.assign(new CaseTable(), {
  ᾦ: '\u1F66\u03B9',
  ᾧ: '\u1F67\u03B9',
  ᾨ: '\u1F60\u03B9',
  ῂ: '\u1F74\u03B9',
  ᾩ: '\u1F61\u03B9',
  ῃ: '\u03B7\u03B9',
  ῄ: '\u03AE\u03B9',
  ῆ: '\u03B7\u0342',
  ῇ: '\u03B7\u0342\u03B9',
  ῢ: '\u03C5\u0308\u0300',
  ΰ: '\u03C5\u0308\u0301',
  ᾪ: '\u1F62\u03B9',
  ß: '\u0073\u0073',
  ῤ: '\u03C1\u0313',
  ᾫ: '\u1F63\u03B9',
  ᾬ: '\u1F64\u03B9',
  ῦ: '\u03C5\u0342',
  ᾭ: '\u1F65\u03B9',
  ῧ: '\u03C5\u0308\u0342',
  ᾮ: '\u1F66\u03B9',
  ﬓ: '\u0574\u0576',
  ᾯ: '\u1F67\u03B9',
  ﬔ: '\u0574\u0565',
  ﬕ: '\u0574\u056B',
  ﬖ: '\u057E\u0576',
  ﬗ: '\u0574\u056D',
  ῌ: '\u03B7\u03B9',
  İ: '\u0069\u0307',
  ǰ: '\u006A\u030C',
  ᾀ: '\u1F00\u03B9',
  ᾁ: '\u1F01\u03B9',
  ᾂ: '\u1F02\u03B9',
  ᾃ: '\u1F03\u03B9',
  ᾄ: '\u1F04\u03B9',
  ᾅ: '\u1F05\u03B9',
  ᾆ: '\u1F06\u03B9',
  ᾇ: '\u1F07\u03B9',
  ᾈ: '\u1F00\u03B9',
  ᾉ: '\u1F01\u03B9',
  ᾊ: '\u1F02\u03B9',
  ᾋ: '\u1F03\u03B9',
  ᾌ: '\u1F04\u03B9',
  ᾍ: '\u1F05\u03B9',
  ᾎ: '\u1F06\u03B9',
  ᾏ: '\u1F07\u03B9',
  ᾲ: '\u1F70\u03B9',
  ᾳ: '\u03B1\u03B9',
  ᾴ: '\u03AC\u03B9',
  ΰ: '\u03C5\u0308\u0301',
  ᾶ: '\u03B1\u0342',
  ᾷ: '\u03B1\u0342\u03B9',
  ῒ: '\u03B9\u0308\u0300',
  ΐ: '\u03B9\u0308\u0301',
  ẖ: '\u0068\u0331',
  ẗ: '\u0074\u0308',
  ﬀ: '\u0066\u0066',
  ẘ: '\u0077\u030A',
  ﬁ: '\u0066\u0069',
  ῖ: '\u03B9\u0342',
  ẙ: '\u0079\u030A',
  ﬂ: '\u0066\u006C',
  ῗ: '\u03B9\u0308\u0342',
  ﬃ: '\u0066\u0066\u0069',
  ﬄ: '\u0066\u0066\u006C',
  ῲ: '\u1F7C\u03B9',
  ﬅ: '\u0073\u0074',
  ῳ: '\u03C9\u03B9',
  ﬆ: '\u0073\u0074',
  ῴ: '\u03CE\u03B9',
  ὐ: '\u03C5\u0313',
  ᾼ: '\u03B1\u03B9',
  ῶ: '\u03C9\u0342',
  ὒ: '\u03C5\u0313\u0300',
  ῷ: '\u03C9\u0342\u03B9',
  ẚ: '\u0061\u02BE',
  ὔ: '\u03C5\u0313\u0301',
  ὖ: '\u03C5\u0313\u0342',
  ẞ: '\u0073\u0073',
  ᾐ: '\u1F20\u03B9',
  ῼ: '\u03C9\u03B9',
  և: '\u0565\u0582',
  ᾑ: '\u1F21\u03B9',
  ᾒ: '\u1F22\u03B9',
  ᾓ: '\u1F23\u03B9',
  ᾔ: '\u1F24\u03B9',
  ŉ: '\u02BC\u006E',
  ᾕ: '\u1F25\u03B9',
  ΐ: '\u03B9\u0308\u0301',
  ᾖ: '\u1F26\u03B9',
  ᾗ: '\u1F27\u03B9',
  ᾘ: '\u1F20\u03B9',
  ᾙ: '\u1F21\u03B9',
  ᾚ: '\u1F22\u03B9',
  ᾛ: '\u1F23\u03B9',
  ᾜ: '\u1F24\u03B9',
  ᾝ: '\u1F25\u03B9',
  ᾞ: '\u1F26\u03B9',
  ᾟ: '\u1F27\u03B9',
  ᾠ: '\u1F60\u03B9',
  ᾡ: '\u1F61\u03B9',
  ᾢ: '\u1F62\u03B9',
  ᾣ: '\u1F63\u03B9',
  ᾤ: '\u1F64\u03B9',
  ᾥ: '\u1F65\u03B9',
});
const simple = Object.assign(new CaseTable(), {
  ᾟ: '\u1F97',
  ᾙ: '\u1F91',
  ᾪ: '\u1FA2',
  ᾫ: '\u1FA3',
  ᾬ: '\u1FA4',
  ᾼ: '\u1FB3',
  ᾭ: '\u1FA5',
  ῌ: '\u1FC3',
  ᾮ: '\u1FA6',
  ᾨ: '\u1FA0',
  ᾊ: '\u1F82',
  ẞ: '\u00DF',
  ᾯ: '\u1FA7',
  ᾩ: '\u1FA1',
  ᾚ: '\u1F92',
  ᾋ: '\u1F83',
  ᾛ: '\u1F93',
  ᾌ: '\u1F84',
  ῼ: '\u1FF3',
  ᾜ: '\u1F94',
  ᾍ: '\u1F85',
  ᾝ: '\u1F95',
  ᾎ: '\u1F86',
  ᾈ: '\u1F80',
  ᾞ: '\u1F96',
  ᾘ: '\u1F90',
  ᾏ: '\u1F87',
  ᾉ: '\u1F81',
});
module.exports = { full, simple };
